import React from 'react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 sm:py-28 lg:py-32 bg-sand relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold/5 rounded-full -ml-48 -mt-48"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-playfair font-light text-navy mb-4 sm:mb-6">
            What Our Clients Say
          </h2>
          <div className="w-12 sm:w-16 h-0.5 bg-burgundy mx-auto"></div>
        </div>

        {/* Single Video Testimonial - 4:5 aspect ratio */}
        <div className="max-w-2xl mx-auto mb-12 sm:mb-16 lg:mb-20">
          <div className="bg-warm-white p-6 sm:p-8 lg:p-10 rounded-2xl shadow-xl">
            {/* Video Container - 4:5 aspect ratio */}
            <div className="aspect-[4/5] rounded-xl overflow-hidden bg-navy mb-6 shadow-lg">
              <video
                controls
                className="w-full h-full object-cover"
                poster="https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/885fctx6_624623072_781554964987700_1951070273906982112_n.jpg"
              >
                <source
                  src="https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/dkedvxa4_WhatsApp%20Video%202026-08-12%20at%2011.12.01%20AM.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Minimal text below video */}
            <div className="text-center pt-4 border-t border-sand">
              <p className="font-manrope font-semibold text-navy text-lg">
                Satisfied Client
              </p>
              <p className="text-sm text-warm-charcoal/60 font-manrope">
                Homeowner, Jamaica
              </p>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <p className="text-base sm:text-lg text-warm-charcoal/70 font-manrope mb-6">
            Join hundreds of satisfied clients who trust Kensetsu
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-burgundy text-warm-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-manrope font-semibold hover:bg-burgundy-dark transition-all duration-300 shadow-md hover:shadow-lg hover:translate-y-[-2px]"
          >
            Start Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
